module.exports = __webpack_public_path__ + "img/bag_ok.ecd2ba64.svg";